exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".IconButton {\n  list-style: none;\n  display: inline-block;\n  vertical-align: top;\n  margin: 0 10px 20px 10px;\n  pointer-events: auto;\n}\n.IconButton .icon {\n  display: block;\n  margin: 0 auto;\n  border-radius: 50%;\n  border: 4px solid #ffffff;\n  background-size: cover;\n  height: 65px;\n  width: 65px;\n}\n.IconButton .text {\n  margin: 5px auto 0;\n  font-size: 14px;\n  font-family: Open Sans, sans-serif;\n  color: #ffffff;\n  max-width: 75px;\n  text-align: center;\n}\n.IconButton .disabled {\n  -webkit-filter: grayscale(100%);\n  /* Safari 6.0 - 9.0 */\n  filter: grayscale(100%);\n}\n\n.desktop .IconButton {\n  margin: 0 5px 10px 5px;\n}\n.desktop .IconButton .icon {\n  height: 45px;\n  width: 45px;\n  border: 1px solid #ffffff;\n}\n.desktop .IconButton .icon:hover {\n  cursor: pointer;\n  box-shadow: 0 0 5px #ffffff;\n}\n.desktop .IconButton .text {\n  width: 65px;\n  font-size: 12px;\n  height: 50px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/scenes/MapContainer/components/DrawerContainer/components/IconButton/IconButton.css
// module id = 871
// module chunks = 0